import { Injectable } from '@angular/core';
import {
    CheckUserName200Response,
    ProfilesService,
} from '@viewbid/ts-angular-client';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UsernameService {
    constructor(private profilesService: ProfilesService) {}

    checkUsernameExists(username: string): Observable<boolean> {
        return this.profilesService.checkUserName(username).pipe(
            map(
                (response: CheckUserName200Response) =>
                    !!response.details?.exists,
            ), // Transform the response to a boolean
        );
    }
}
